import React from 'react';
import { useParams } from 'react-router';

// Components
import { WpModal } from 'Wpds/components/modal';
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpPageLayout, WpPageBody, WpPageHeader, WpPageTitle } from 'Wpds/components/page-layout';
import FeedbackTeammateInfo from '../FeedbackCreationPage/FeedbackForm/FeedbackFormSection/FeedbackTeammateInfo/FeedbackTeammateInfo';
import FeedbackTemplateSelect from './FeedbackTemplateSelect';

// Styles
import './GiveFeedbackModal.scss';
import { useFeature } from 'Shared/utils/hooks';
import { Feature } from 'Shared/types/Organization.type';

type Props = {
  isOpen: boolean;
  toggleOpen: () => void;
  handleChooseTemplate: Function;
};

const GiveFeedbackModal = ({ isOpen = false, toggleOpen, handleChooseTemplate }: Props) => {
  const { workspaceId } = useParams();
  const { isActive: isKudosActive } = useFeature(Feature.kudos);
  const title = isKudosActive ? 'Give Feedback & Kudos' : 'Give Feedback';

  const baseClassName = 'GiveFeedbackModal';
  return (
    <WpModal size="full" isOpen={isOpen}>
      <WpPageLayout width="container">
        <WpPageHeader slim>
          <div className={`${baseClassName}__header`}>
            {!workspaceId && <WpPageTitle title={title} />}
            <div className={`${baseClassName}__header__close-btn`}>
              <WpButton variant="tertiary" onClick={toggleOpen}>
                <WpIcon name="times" />
              </WpButton>
            </div>
          </div>
        </WpPageHeader>
        <WpPageBody>
          {workspaceId && <FeedbackTeammateInfo isEditFeedback={false} />}
          <FeedbackTemplateSelect handleChooseTemplate={handleChooseTemplate} />
        </WpPageBody>
      </WpPageLayout>
    </WpModal>
  );
};

export default GiveFeedbackModal;
